import React, { FC } from "react";
import { Routes, Route } from "react-router-dom";
import ClientEdit from "./ClientEdit";
import ClientList from "./ClientList";

export const ClientsRouter: FC<{}> = () => {
  return (
    <Routes>
        <Route path="/:id" element={<ClientEdit />} />
         <Route path="/" element={<ClientList />} />
    </Routes>
  );
};
